import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';

import ButtonsUseStyles from 'consts/styles/Buttons';
import { formStyles } from 'consts/styles/Form';

const AddPeriodicForm = props => {
  const {
    language,
    weekdays,
    toggleWeekdays,
    days,
    hours,
    toggleHours,
    pickedHours,
  } = props;
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  return (
    <>
      {weekdays && (
        <>
          <div
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center `}
          >
            <p
              className={`${formClasses.Form}__text-field__form-helper--error`}
            >
              {language.utcInfo_}
            </p>
          </div>
          <div
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center `}
          >
            <Typography
              variant="h3"
              className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
            >
              {language.zonesDetails.addForm.activationForm.periodicDayInfo_}
            </Typography>
          </div>
          <div
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center `}
          >
            {Object.values(language.weekDays).map((weekday, index) => (
              <Button
                key={`weekDays${index}`}
                onClick={() => toggleWeekdays(weekday)}
                className={`${classesButtons.Buttons} ${
                  classesButtons.Buttons
                }--color ${classesButtons.ButtonsRectangle} ${days.includes(
                  weekdays[weekday]
                ) && `${classesButtons.Buttons}__active`}`}
              >
                {weekday.slice(0, 3)}
              </Button>
            ))}
          </div>
        </>
      )}
      {hours && (
        <Grid
          container
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center `}
        >
          <Grid item xs={12}>
            <Typography
              variant="h3"
              className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
            >
              {language.zonesDetails.addForm.activationForm.periodicHourInfo_}
            </Typography>
          </Grid>
          {hours.map((eachHour, index) => (
            <Grid key={`hours${index}`} item lg={1} xs={2}>
              <Button
                onClick={() => toggleHours(eachHour)}
                className={`${classesButtons.Buttons} ${
                  classesButtons.Buttons
                }--color ${classesButtons.ButtonsRectangle} 
                     ${pickedHours.includes(eachHour) &&
                       `${classesButtons.Buttons}__active`}`}
              >
                {eachHour}:00
              </Button>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};
AddPeriodicForm.propTypes = {
  language: PropTypes.object.isRequired,
  weekdays: PropTypes.object.isRequired,
  toggleWeekdays: PropTypes.func.isRequired,
  days: PropTypes.array.isRequired,
  hours: PropTypes.array.isRequired,
  toggleHours: PropTypes.func.isRequired,
  pickedHours: PropTypes.array.isRequired,
};
const mapStateToProps = state => ({
  language: state.language,
});
export default connect(mapStateToProps)(AddPeriodicForm);
